import { withInstall } from '../utils/type';
import RouterMenu from './RouterMenu';
import _RouterMenuItem from './RouterMenuItem';
export { getMenuFromRoutes, getRouterMenus, findChildren, findParentKeys } from './RouterMenu';
export var RouterMenuItem = _RouterMenuItem;
export default withInstall(RouterMenu, _RouterMenuItem);